import { IClient, ActionType, ICentraClient, IAccountManager } from './model'
import createReducer from '../createReducer'
import { Action, Nullable } from '../model'
import { OptionType } from 'components/shared/Form/models'

export interface IClientsReducer {
  client: Nullable<IClient>
  clientLoading: boolean
  clients: Nullable<IClient[]>
  clientsLoading: boolean
  centraClients: Nullable<ICentraClient[]>
  clientsOptions: OptionType[]
  clientsOptionsLoading: boolean
  accountManagers: IAccountManager[]
}

const defaultState: IClientsReducer = {
  client: null,
  clientLoading: true,
  clients: null,
  clientsLoading: true,
  centraClients: null,
  clientsOptions: [],
  clientsOptionsLoading: true,
  accountManagers: [],
}

export const clientsReducer = createReducer<IClientsReducer>(defaultState, {
  [ActionType.SET_CLIENT](state: IClientsReducer, action: Action) {
    return { ...state, client: action.payload, clientLoading: false }
  },

  [ActionType.GET_CLIENT](state: IClientsReducer) {
    return { ...state, clientLoading: true }
  },

  [ActionType.SET_CLIENTS](state: IClientsReducer, action: Action) {
    return { ...state, clients: action.payload, clientsLoading: false }
  },

  [ActionType.GET_CLIENTS](state: IClientsReducer) {
    return { ...state, clientsLoading: true }
  },

  [ActionType.SET_CENTRA_CLIENTS](state: IClientsReducer, action: Action) {
    return {
      ...state,
      centraClients: action.payload,
    }
  },

  [ActionType.GET_CLIENTS_OPTIONS](state: IClientsReducer) {
    return { ...state, clientsOptionsLoading: true }
  },

  [ActionType.SET_CLIENTS_OPTIONS](state: IClientsReducer, action: Action) {
    return { ...state, clientsOptions: action.payload, clientsOptionsLoading: false }
  },

  [ActionType.SET_ACCOUNT_MANAGERS](state: IClientsReducer, action: Action) {
    return { ...state, accountManagers: action.payload }
  },
})
